import { useState } from 'react';
import * as React from 'react';
import { faMagnifyingGlass, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { withIcon } from './Icon';
import { useControllableState } from '../utils/useControllableState';
import classnames from '../utils/classnames';

const SearchIcon = withIcon(faMagnifyingGlass);
const ClearIcon = withIcon(faTimes);

const SearchField = ({ defaultValue = '', value: propsValue, onValueChange, placeholder }: any) => {
    const [value, setValue] = useControllableState(defaultValue, propsValue, onValueChange);

    const [isFocused, setIsFocused] = useState(false);

    return (
        <div
            // if it is empty and not focused it acts like a button otherwise like a field
            className={classnames(
                'text-sm relative h-8 border border-line-transparent outline-transparent border-solid rounded transition-all min-w-[80px]',
                value && 'border-line-strong sm:min-w-[300px] hover:border-line-brand-default',
                isFocused &&
                    'border-line-brand-default !outline outline-line-brand-weak outline-2 !bg-surface-weak sm:min-w-[300px] hover:border-line-brand-default',
                !isFocused && !value && 'hover:bg-surface-strong'
            )}
        >
            <SearchIcon className="absolute pointer-events-none top-1/2 left-3 transform -translate-y-1/2 z-10 text-sm text-content-strong" />

            <button
                className={classnames(
                    'absolute h-full w-8 right-0 z-10 text-sm hover:bg-surface-strong hover:text-content-strong rounded-full transition-all',
                    value ? 'opacity-100' : 'opacity-0 pointer-events-none'
                )}
                onClick={() => setValue('')}
            >
                <ClearIcon />
            </button>

            <input
                className={classnames(
                    'absolute inset-0 w-full h-full pl-8 pr-3 cursor-pointer placeholder-content-strong font-medium rounded bg-surface-transparent text-content-strong outline-none',
                    isFocused && !value && 'font-normal placeholder-secondary',
                    value && 'pr-10 font-normal'
                )}
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
            />
            <div
                className={classnames(
                    'pl-8 pr-3 font-medium text-sm pointer-events-none border border-line-transparent bg-surface-transparent opacity-0',
                    value && 'pr-10'
                )}
            >
                {value || placeholder}
            </div>
        </div>
    );
};

export default SearchField;
